import { createTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { ThemeProvider } from "@mui/material";
import { enUS, huHU } from "@mui/material/locale";

const createLocalizedTheme = (locale) =>
  createTheme(
    {
      palette: {
        primary: {
          main: "#0A84FF",
        },
        background: {
          default: "#303030",
          paper: "#212121",
        },
        greenProject: {
          main: "#385723",
          dark: "#385723",
          contrastText: "#ffffff"
        },
        redProject: {
          main: "#670C0B",
          dark: "#670C0B",
          contrastText: "#ffffff"
        },
        mode: "dark",
      },
      components: {
        MuiAppBar: {
          styleOverrides: {
            root: ({ theme }) => ({
              backgroundColor: theme.palette.background.paper,
              backgroundImage: "none",
            }),
          },
        },
      },
    },
    locale
  );

export const LocalizedThemeProvider = ({ children }) => {
  const { i18n, } = useTranslation();
  const muiLocale = useMemo(() => {
    switch (i18n.language) {
      case "hu":
        huHU.components.MuiTablePagination.defaultProps.labelDisplayedRows = ({
          from,
          to,
          count,
        }) => `${from}-${to}${count !== -1 ? ` / ${count}` : ""}`;
        return huHU;
      default:
        return enUS;
    }
  }, [i18n]);
  const themeWithLocale = useMemo(
    () => createLocalizedTheme(muiLocale),
    [muiLocale]
  );

  return <ThemeProvider theme={themeWithLocale}>{children}</ThemeProvider>;
};
